<template>
    <button :class="computedClasses" @click="$emit('click')">
        <slot />
    </button>
</template>

<script>
export default {
    name: 'BaseCircleButton',
    props: {
        active: { type: Boolean, default: false },
    },
    computed: {
        computedClasses() {
            return [
                'ppv2-w-9',
                'ppv2-h-9',
                'ppv2-rounded-full',
                'ppv2-border',
                'ppv2-border-solid',

                this.active
                    ? 'poppinsSemiBold bg-purple ppv2-bg-opacity-80 ppv2-border-[#44007B] ppv2-text-white'
                    : 'poppinsLight ppv2-bg-white ppv2-bg-opacity-5 ppv2-border-[#5B5B9C] ppv2-text-black',
            ]
        },
    },
}
</script>
